import type { BooleanFieldSchema } from '@carboncopyco/editor-utils';
import { DropdownFilter } from '@carboncopyco/ui';
import classNames from 'classnames';
import { FieldPanel } from './FieldPanel';
import type { BaseFieldProps } from './types';
import { useDebouncedValue } from './useDebouncedValue';

export type BooleanFieldProps = BaseFieldProps<BooleanFieldSchema, boolean>;

export const BooleanField = ({
  value,
  field,
  readOnly,
  editableField,
  onChangeField,
  onChangeValue,
  onRemoveField,
}: BooleanFieldProps) => {
  const [innerValue, setInnerValue] = useDebouncedValue(value, onChangeValue);

  return (
    <FieldPanel
      field={field}
      editable={editableField}
      onChange={onChangeField}
      onRemoveField={onRemoveField}
    >
      <span className={classNames('w-20', readOnly && 'pointer-events-none')}>
        <DropdownFilter
          placeholder="Type"
          items={[
            { id: 'true', label: 'True' },
            { id: 'false', label: 'False' },
          ]}
          onSelect={(id) => setInnerValue?.({ true: true, false: false }[id])}
          selected={innerValue ? 'true' : 'false'}
          contentWidth={200}
        />
      </span>
    </FieldPanel>
  );
};
